import LegalLayout from "./LegalLayout";

const S = ({ n, title, children, testid }) => (
  <section data-testid={testid} className="mt-12">
    <h2 className="font-display text-xl font-medium tracking-tight text-white">
      <span className="mr-3 text-sm font-light text-cyan-300/70">{n}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-[#C5CBD5]">{children}</div>
  </section>
);

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" updated="Last updated: October 2026" testid="cookie-policy-page">
      <S n="01" title="What This Policy Covers" testid="cookie-s1">
        <p>
          This Cookie Policy explains how AIROBOTCAMSTUDIO LTD (UK Company No. 17410621) uses
          cookies and similar browser technologies — such as local storage — on
          airobotcamstudio.com. It should be read together with our Privacy Policy.
        </p>
      </S>

      <S n="02" title="What We Actually Use" testid="cookie-s2">
        <p>
          This website sets no tracking cookies. The complete list of browser technologies we use
          is intentionally short:
        </p>
        <p>
          <span className="text-white/85">Consent preference (strictly necessary).</span> When you
          accept or reject optional analytics, your choice is stored in your browser's local
          storage so the banner does not reappear on every page and your decision is honoured.
          This record contains no personal information beyond the choice itself and the date it
          was made.
        </p>
        <p>
          <span className="text-white/85">Cookieless analytics (optional).</span> If you accept
          analytics, a small first-party script records page views anonymously. It sets no cookies
          and stores nothing in your browser.
        </p>
      </S>

      <S n="03" title="Strictly Necessary" testid="cookie-s3">
        <p>
          The consent preference described above is strictly necessary for the consent system to
          function: without it we could not remember or honour your choice. It is always active
          and is not used for any other purpose.
        </p>
      </S>

      <S n="04" title="Analytics (Optional)" testid="cookie-s4">
        <p>
          With your consent, we use privacy-friendly, first-party analytics to understand how the
          website is used. The system is cookieless by design: it records the page viewed, the
          referring site, your browser timezone and device category, and an anonymous identifier
          that rotates daily and cannot identify you. No data is shared with advertising networks,
          no cross-site tracking takes place, and no third-party analytics services are used.
        </p>
        <p>
          Analytics are only activated after you choose Accept. Choosing Reject keeps them fully
          disabled, and no analytics requests are made before a choice is given.
        </p>
      </S>

      <S n="05" title="Third Parties" testid="cookie-s5">
        <p>
          We use no advertising pixels, marketing trackers or social media widgets. The social
          media icons in our footer are plain links and load nothing from those platforms.
        </p>
        <p>
          The optional live AI companion preview on our homepage is provided by LemonSlice. When
          you choose to open a session, your browser connects to LemonSlice's service, which may
          use its own cookies or similar technologies under LemonSlice's privacy policy.
        </p>
      </S>

      <S n="06" title="Managing or Withdrawing Consent" testid="cookie-s6">
        <p>
          You can change or withdraw your consent at any time by selecting Cookie Preferences in
          the website footer, which reopens the preferences panel. Rejecting analytics disables
          them from that point on. You can also clear the stored choice at any time by clearing
          this site's data in your browser settings, which will cause the banner to appear again
          on your next visit.
        </p>
      </S>

      <S n="07" title="Changes and Contact" testid="cookie-s7">
        <p>
          We may update this policy as the website develops; the current version will always be
          available on this page with its revision date. Questions about this policy can be sent
          to info@airobotcamstudio.com.
        </p>
      </S>
    </LegalLayout>
  );
}
